import { useState, useMemo } from 'react'

import AivatarClient, { API_TYPE } from '../AivatarClient'
import { CALL_STATE } from '../constants'
import useConstantProperties from '../utils/useConstantProperties'

export default function useListenExportAudio() {
  /** Recoils */

  /** poolVotes */
  const [res, setRes] = useState(null)
  const [apiState, setApiState] = useState(CALL_STATE.NEW)
  const { isCallSuccess, isLoading } = useConstantProperties(apiState)

  const fetch = async ({ id }) => {
    try {
      setApiState(CALL_STATE.FETCHING)
      const fetchRes = await AivatarClient({
        type: API_TYPE.BLOB,
      }).get(`audios/${id}/concat`)
      setApiState(CALL_STATE.SUCCESS)
      setRes(fetchRes)
      if (fetchRes?.status !== 200) throw new Error('useListenExportAudio - invalid status')
      if (!fetchRes?.data) throw new Error('useListenExportAudio - invalid data')

      return URL.createObjectURL(fetchRes.data)
    } catch (error) {
      console.error('useListenExportAudio', error)
      setApiState(CALL_STATE.ERROR)
      setRes(null)
      throw new Error('useListenExportAudio', error)
    }
  }

  const init = () => {
    setRes(null)
    setApiState(CALL_STATE.NEW)
  }

  /** Status */
  const isValidStatus = useMemo(() => res?.status === 200, [res])
  /** data */
  const data = useMemo(() => {
    if (!isValidStatus) return null
    return res.data
  }, [res, isValidStatus])

  const url = useMemo(() => {
    if (!data) return null
    return URL.createObjectURL(data)
  }, [data])

  return {
    isLoadingListenExportAudio: isLoading,
    isCallSuccessListenExportAudio: isCallSuccess,
    url,

    fetchListenExportAudio: fetch,
    initListenExportAudio: init,
  }
}
